/**
 * Component Registry for Dolben Theme
 *
 * Extends the base rise theme registry with Dolben specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-rise/registry';
import { AmenitiesList } from './components/AmenitiesList';
import { ApplyCtaBanner } from './components/ApplyCtaBanner';
import { CommunityFilmEmbed } from './components/CommunityFilmEmbed';
import { ContactForm } from './components/ContactForm';
import { ContactInfoCards } from './components/ContactInfoCards';
import { FloorplansList } from './components/FloorplansList';
import { Footer } from './components/Footer';
import { Gallery } from './components/Gallery';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { HeroSolidBG } from './components/HeroSolidBG';
import { IncomeRestrictedContent } from './components/IncomeRestrictedContent';
import { InteractiveMapCta } from './components/InteractiveMapCta';
import { LifestyleIntro } from './components/LifestyleIntro';
import { NeighborhoodDiscover } from './components/NeighborhoodDiscover';
import { NeighborhoodMap } from './components/NeighborhoodMap';
import { PinnedCallouts } from './components/PinnedCallouts';
import { PropertyOverview } from './components/PropertyOverview';
import { RetailLeasingContact } from './components/RetailLeasingContact';
import { RetailShops } from './components/RetailShops';
import { ReviewsCallout } from './components/ReviewsCallout';
import { SitemapContent } from './components/SitemapContent';
import { SpecialOfferBanner } from './components/SpecialOfferBanner';
import { TermsAndConditionsContent } from './components/TermsAndConditionsContent';
import { ThankYouContent } from './components/ThankYouContent';
import { VirtualTourEmbed } from './components/VirtualTourEmbed';

/**
 * Dolben specific component overrides.
 * These components have been customized for the Dolben brand.
 */
const dolbenOverrides: Partial<ComponentRegistry> = {
  AmenitiesList,
  ApplyCtaBanner,
  CommunityFilmEmbed,
  ContactForm,
  ContactInfoCards,
  FloorplansList,
  Footer,
  Gallery,
  Header,
  Hero,
  HeroSolidBG,
  IncomeRestrictedContent,
  InteractiveMapCta,
  LifestyleIntro,
  NeighborhoodDiscover,
  NeighborhoodMap,
  PinnedCallouts,
  PropertyOverview,
  RetailLeasingContact,
  RetailShops,
  ReviewsCallout,
  SitemapContent,
  SpecialOfferBanner,
  TermsAndConditionsContent,
  ThankYouContent,
  VirtualTourEmbed,
};
/**
 * Final merged registry for Dolben properties.
 * Inherits all components from the rise theme, with Dolben overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...dolbenOverrides,
};

export default registry;
